import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'zag-card-title',
  templateUrl: './zag-card-title.component.html',
  styleUrl: './zag-card-title.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ZagCardTitleComponent {}
